import React, { useEffect, useState } from "react";
import personalArrow from "../../../assets/images/personal-arrow.svg";
import personalMap from "../../../assets/images/leap-map.svg";
import BookedTourCard from "./BookedTourCard";
import ConfirmationBooking from "../../../components/ConfirmationBooking";
import TICKET from "../../../assets/images/TICKET.webp";
import axios from "axios";

export default function CurrentDate({
  date,
  dataObject,
  index,
  selectedIndex,
  bookingsByDate,
  tourNameArr,
  tourCategoriesArr,
  setIsChangeModalOpen,
  setIsCancelModalOpen,
  processedVenues,
}) {
  const [isConfirmationCardVisible, setIsConfirmationCardVisible] =
    useState(false);

  const toggleConfirmationCard = () => {
    setIsConfirmationCardVisible((prevState) => !prevState);
  };

  const [responseData, setResponseData] = useState();
  const [tempHtml, setTempHtml] = useState();
  const [loading, setLoading] = useState(true); // State to track loading status
  const [noCompanies, setNoCompanies] = useState(false); // State to track loading status

  const tours_ids = dataObject
    ?.flatMap((tour) => tour?.items?.map((item) => item?.tour_id))
    ?.filter((id) => id)
    ?.join(",");

  useEffect(() => {
    const getCompanies = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_ECOMMERCE_BASE_URL}/api/v1/display_products_by_ids`,
          {
            params: {
              products_id: tours_ids,
            },
            headers: {
              apikey: "5f28583f26a1a",
              "Accept-language": "en",
              apiconnection: "appmobile",
              "secure-business-key": process.env.REACT_APP_BUSINESS_KEY,
            },
          }
        );

        if (response?.data.status === true) {
          setResponseData(response?.data.data);
        }
      } catch (error) {}
    };

    getCompanies();
  }, []);

  return (
    <div key={date} className="leap-flex leap-flex-col leap-gap-10 leap-my-7">
      <div className="leap-flex leap-flex-row leap-justify-between leap-px-2">
        <h1 className="custom-white-border leap-relative leap-text-[20px] lg:leap-text-[40px] leap-font-bold leap-text-white">
          {new Date(date).toLocaleDateString("en-US", {
            month: "long",
            day: "numeric",
          })}
        </h1>
        <button
          className={`leap-text-[#C4C4C4] leap-font-bold leap-text-[15px] leap-my-auto leap-flex leap-gap-3 ${
            selectedIndex === index && isConfirmationCardVisible
              ? "!leap-text-white "
              : ""
          }`}
          onClick={toggleConfirmationCard}
        >
          View QR
          <span
            className={`leap-p-[2px] leap-rounded-[2px] ${
              selectedIndex === index && isConfirmationCardVisible
                ? "leap-bg-white "
                : "leap-bg-transparent"
            }`}
          >
            <img src={personalArrow} alt="" loading="lazy" />
          </span>
        </button>
      </div>

      <div
        className={`cards leap-grid leap-gap-6 leap-grid-cols-1 lg:leap-grid-cols-2 xl:leap-grid-cols-3 2xl:leap-grid-cols-4
       `}
      >
        {Array.isArray(dataObject) &&
          dataObject?.map((obj) =>
            obj?.items
              ?.filter((item) => item.status !== "cancelled")
              ?.map((item, index) => (
                <BookedTourCard
                  key={index}
                  imageSrc={TICKET}
                  title={
                    tourCategoriesArr?.find(
                      (detail) =>
                        String(detail.id) === String(item?.category_ids)
                    )?.title || "Category Name"
                  }
                  tourType={
                    tourNameArr?.find(
                      (detail) => String(detail.id) === String(item?.tour_id)
                    )?.name || "Tour Name"
                  }
                  startFrom={
                    processedVenues?.find(
                      (venue) => venue.venueId == item?.venue_id
                    )?.startGate || "Start"
                  }
                  startAt={item.start_time}
                  itemId={item?.item_id || "1"}
                  current_tour_id={item?.tour_id}
                  endAt={
                    processedVenues?.find(
                      (venue) => venue.venueId == item?.venue_id
                    )?.endGate || "End"
                  }
                  endTime={item.end_time}
                  date={date}
                  attendanceId={obj.attendance_id}
                  tour_name={responseData}
                  setIsChangeModalOpen={setIsChangeModalOpen}
                  setIsCancelModalOpen={setIsCancelModalOpen}
                />
              ))
          )}

        {isConfirmationCardVisible && (
          <div>
            <div
              className={`leap-z-50 leap-fixed leap-top-0 leap-left-0 leap-w-full leap-h-full leap-flex leap-justify-center leap-items-center leap-bg-black/50 leap-transition-opacity leap-duration-300 ${
                isConfirmationCardVisible
                  ? "leap-opacity-100 leap-scale-100 leap-block"
                  : "leap-hidden leap-scale-90"
              }`}
            >
              <ConfirmationBooking
                onClick={toggleConfirmationCard}
                date={date}
                bookingsByDate={bookingsByDate}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
